import {BusJsonDataEnum} from './BusJsonDataEnum';

export const BusFormDataEnum = {
  DESTINATION_NAME: BusJsonDataEnum.DESTINATION_NAME,
  LINK_NUMBER: BusJsonDataEnum.LINK_NUMBER,
  MAIN_TYPE: BusJsonDataEnum.MAIN_TYPE,
  TYPE: BusJsonDataEnum.TYPE
};



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/Map/BusFormDataEnum.js